import { StreamListFilterParams } from '@anm/api/modules/stream';
import { uploadsActions } from '@anm/store/modules/uploads';
import { useDispatch, useSelector } from 'react-redux';

import { streamActions } from '../../../store/modules/stream';
import { userSelectors } from '../../../store/modules/user';
import { videoFolderActions } from '../../../store/modules/videoFolder';
import { getStreamParams } from '../MyStreamsSection/helpers';

import { TAB } from '.';

export const useActiveTab = (tabIndex: TAB) => {
  const canLiveStream = useSelector(userSelectors.selectCanLiveStream);
  const hasProfile = !!useSelector(userSelectors.selectUserProfile);

  const currentTab = (canLiveStream ? tabIndex : tabIndex - 1) as TAB;
  const activeTab = hasProfile ? currentTab : (-1 as TAB);

  return activeTab;
};

export const useFetchRootVideosHandler = () => {
  const dispatch = useDispatch();

  const isForceLoad = true;
  const fetchRootFolder = () => {
    dispatch(videoFolderActions.fetchRootFolder(isForceLoad));
  };

  return fetchRootFolder;
};

export const useFetchStreamsUpcoming = () => {
  const dispatch = useDispatch();

  const params = getStreamParams('upcoming') as StreamListFilterParams;

  const handleFetchStreams = () => dispatch(streamActions.fetchStreamsList(params));

  return handleFetchStreams;
};

export const useReFetchUploads = () => {
  const dispatch = useDispatch();

  const handleFetchUploads = () => {
    dispatch(uploadsActions.updateBreadcrumbs(null));
  };

  return handleFetchUploads;
};
